module.exports = __webpack_public_path__ + "static/media/statistics-2899919.db861dbf.jpg";